module.exports = __webpack_public_path__ + "img/ball-4.e42415f5.png";